import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from "react";
import { ScrollView as rScrollView } from "react-native";
import { useSx } from "../use-sx";
import { styled } from "../css/styled";
var DripsyScrollView = styled(rScrollView)();
export var ScrollView = /*#__PURE__*/ forwardRef(function ScrollView(props, ref) {
    var sx = useSx();
    var containerSx = props.contentContainerSx && sx(props.contentContainerSx);
    var indicatorSx = props.indicatorSx && sx(props.indicatorSx);
    return /*#__PURE__*/ _jsx(DripsyScrollView, _object_spread_props(_object_spread({}, props), {
        contentContainerStyle: props.contentContainerStyle && containerSx ? [
            props.contentContainerStyle,
            containerSx
        ] : containerSx || props.contentContainerStyle,
        indicatorStyle: props.indicatorStyle && indicatorSx ? [
            props.indicatorStyle,
            indicatorSx
        ] : indicatorSx || props.indicatorStyle,
        ref: ref
    }));
});
